// src/molecules/SubHeader.tsx
import {
  Box,
  Flex,
  HStack,
  ResponsiveValue,
  useBreakpointValue,
  Badge,
  Button,
} from '@chakra-ui/react';
import { IoTicketOutline } from 'react-icons/io5';
import { FaGlobe } from 'react-icons/fa';
import { CustomDropdown } from '../atoms/CustomDropdown';

interface SubHeaderProps {
  // platforms: string[]; // Array of platform names
  currentLanguage: string; // Currently selected language
  supportedLanguages?: { label: string; value: string }[];
  onLanguageChange: (item: string) => void;
  horizontalPadding?: ResponsiveValue<string>; // Optional horizontal padding type
  textColor: string;
  subHeaderBgColor: string;
  subHeaderTextColor: string;
  onClickMyTickets: () => void;
  myTicketsHref?: () => string | undefined;
  myTicketsButtonText: string;
  secondaryAccentColor: string;
  unreadMessageCount?: number;
}
export const SubHeader: React.FC<SubHeaderProps> = ({
  currentLanguage,
  supportedLanguages,
  onLanguageChange,
  horizontalPadding,
  subHeaderTextColor,
  onClickMyTickets,
  myTicketsHref,
  myTicketsButtonText,
  secondaryAccentColor,
  unreadMessageCount = 0,
}) => {
  const showLabels = useBreakpointValue({ base: false, lg: true });

  return (
    <Box bgGradient="linear(to-r, rgba(0,0,0,0.5), rgba(0,0,0,0.3))" px={horizontalPadding}>
      <Flex
        alignItems="center"
        justify={{ base: 'space-between', md: 'flex-end' }}
        flexDirection="row"
        wrap="nowrap"
        width="100%"
      >
        {/* Left side: Dropdown */}
        <Box>
          <CustomDropdown
            label={currentLanguage?.toUpperCase()}
            value={currentLanguage}
            items={supportedLanguages?.map(lang => lang.label) ?? []}
            leftIcon={<FaGlobe color={secondaryAccentColor} />}
            onItemClick={onLanguageChange}
            textColor={subHeaderTextColor}
            dropdownBgColor={secondaryAccentColor}
          />
        </Box>

        {/* Right side: Button */}
        <Box position="relative">
          {/* <CustomButton
            variant="ghost"
            backgroundColor="transparent"
            color={subHeaderTextColor}
            mt={{ base: 1, sm: 0, lg: 1 }}
            width={{ base: 'fit-content', sm: 'auto' }}
            onClick={onClickMyTickets}
            size="sm"
            fontWeight="semibold"
            fontFamily="Noto Sans JP, sans-serif"
          >
            {showLabels ? (
              <HStack spacing={2}>
                <IoTicketOutline color={secondaryAccentColor} size={18} />
                <Box as="span">{myTicketsButtonText}</Box>
              </HStack>
            ) : (
              <IoTicketOutline color={secondaryAccentColor} size={18} />
            )}
          </CustomButton> */}
          <a href={myTicketsHref ? myTicketsHref() : undefined}>
            <Button
              variant="ghost"
              backgroundColor="transparent"
              color={subHeaderTextColor}
              mt={{ base: 1, sm: 0, lg: 1 }}
              width={{ base: 'fit-content', sm: 'auto' }}
              onClick={e => {
                const isLeftClick = e.button === 0;
                const isModifiedClick = e.metaKey || e.ctrlKey || e.shiftKey || e.altKey;
                // SPA routing on normal click
                if (isLeftClick && !isModifiedClick) {
                  e.preventDefault();
                  onClickMyTickets();
                }
              }}
              size="sm"
              fontWeight="semibold"
              fontFamily="Noto Sans JP, sans-serif"
              colorScheme="black"
            >
              {showLabels ? (
                <HStack spacing={2}>
                  <IoTicketOutline color={secondaryAccentColor} size={18} />
                  <Box as="span">{myTicketsButtonText}</Box>
                </HStack>
              ) : (
                <Box textAlign="center" display="flex" flexDirection="column" alignItems="center">
                  <Box transform="translateX(-2px)">
                    <IoTicketOutline color={secondaryAccentColor} size={18} />
                  </Box>
                  <Box
                    as="span"
                    fontSize="xs"
                    mt={0.5}
                    color={subHeaderTextColor}
                    transform="translateX(-2px)"
                  >
                    {myTicketsButtonText}
                  </Box>
                </Box>
              )}
            </Button>
          </a>
          {/* Badge only if unreadMessageCount > 0 */}
          {unreadMessageCount > 0 && (
            <Badge
              position="absolute"
              top="-2px"
              right="-2px"
              borderRadius="full"
              bg="red.500"
              color="white"
              fontSize="0.7rem"
              px={2}
              py={0.5}
            >
              {unreadMessageCount}
            </Badge>
          )}
        </Box>
      </Flex>
    </Box>
  );
};
